var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6268 0.0673828H7.7748C7.35046 0.0673828 6.94349 0.235954 6.64343 0.536012C6.34338 0.83607 6.1748 1.24304 6.1748 1.66738V38.3384C6.17613 38.7619 6.34528 39.1675 6.6452 39.4665C6.94511 39.7655 7.35132 39.9334 7.7748 39.9334H32.2248C32.6474 39.9321 33.0523 39.7636 33.3512 39.4648C33.65 39.1659 33.8185 38.761 33.8198 38.3384V8.26038L25.6268 0.0673828Z",
    fill: "#F5F6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.627 8.26038H33.82L25.627 0.0673828V8.26038Z",
    fill: "#DBDDDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.647 29.8483H5.35304C5.07111 29.8483 4.80074 29.7363 4.60138 29.5369C4.40203 29.3376 4.29004 29.0672 4.29004 28.7853V19.4263C4.29004 19.1444 4.40203 18.874 4.60138 18.6746C4.80074 18.4753 5.07111 18.3633 5.35304 18.3633H34.647C34.929 18.3633 35.1993 18.4753 35.3987 18.6746C35.598 18.874 35.71 19.1444 35.71 19.4263V28.7853C35.71 29.0672 35.598 29.3376 35.3987 29.5369C35.1993 29.7363 34.929 29.8483 34.647 29.8483Z",
    fill: "#49B3B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5198 22.1662V23.8882H15.2528V24.7782H12.5198V26.9452H11.4678V21.2842H15.5998V22.1662H12.5198Z",
    fill: "#F5F6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 21.2842H17.7517V26.9452H16.6997V21.2842Z",
    fill: "#F5F6F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3599 21.2842H20.4119V26.0552H23.3719V26.9452H19.3599V21.2842Z",
    fill: "#F5F6F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5316 26.0632V26.9452H24.2856V21.2842H28.4186V22.1662H25.3376V23.6372H28.0706V24.5002H25.3376V26.0602L28.5316 26.0632Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileType);
export default __webpack_public_path__ + "static/media/file_type.3fd2d5159f762bae202c1952e52c724b.svg";
export { ForwardRef as ReactComponent };